import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { Download, Inbox, RefreshCw } from "lucide-react";
import { getModeratorToken } from "../lib/dailyNewsApi";

const API = process.env.REACT_APP_BACKEND_URL || "";
const headers = () => ({ "x-moderator-token": getModeratorToken() });

async function fetchReports() {
  const response = await axios.get(`${API}/api/v1/general-reports`, { headers: headers(), timeout: 8000 });
  return response.data?.items || [];
}

async function updateState(id, state) {
  const body = new FormData();
  body.append("state", state);
  await axios.post(`${API}/api/v1/general-reports/${encodeURIComponent(id)}/status`, body, { headers: headers(), timeout: 8000 });
}

async function downloadAttachment(reportId, item) {
  const response = await axios.get(`${API}/api/v1/general-reports/${encodeURIComponent(reportId)}/attachments/${encodeURIComponent(item.id)}`, {
    headers: headers(), responseType: "blob", timeout: 30000,
  });
  const url = URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = item.name || "allegato";
  link.click();
  URL.revokeObjectURL(url);
}

export function AdminGeneralReports() {
  const [items, setItems] = useState([]);
  const [state, setState] = useState("loading");
  const [error, setError] = useState("");
  const load = useCallback(async () => {
    setState("loading"); setError("");
    try { setItems(await fetchReports()); setState("ready"); }
    catch (err) { setError(err?.response?.status === 401 ? "Credenziale non valida." : "Segnalazioni generali non disponibili."); setState("error"); }
  }, []);
  useEffect(() => { load(); }, [load]);
  const changeState = async (id, next) => { await updateState(id, next); await load(); };

  return <section className="mt-8 border-t border-edge pt-6" data-testid="admin-general-reports">
    <div className="mb-4 flex items-center gap-2"><Inbox className="text-primary" size={20} /><div><h2 className="text-xl">Segnalazioni generali</h2><p className="text-xs text-muted">Problemi, sicurezza, comportamenti e suggerimenti inviati dal menu.</p></div><button type="button" onClick={load} className="ml-auto p-2" aria-label="Aggiorna segnalazioni generali"><RefreshCw size={18} className={state === "loading" ? "animate-spin" : ""} /></button></div>
    {error && <div className="card p-4 text-primary">{error}</div>}
    {state === "ready" && items.length === 0 && <div className="card p-6 text-center text-muted">Nessuna segnalazione generale.</div>}
    <div className="space-y-3">{items.map((item) => <article key={item.id} className="card p-4">
      <div className="flex flex-wrap items-center gap-2"><span className="text-xs font-bold uppercase tracking-wider text-primary">{item.categoryLabel}</span><span className="rounded-full bg-cream px-2 py-1 text-xs">{item.state}</span><span className="ml-auto text-xs text-muted">{new Date(item.createdAt).toLocaleString("it-IT")}</span></div>
      <p className="mt-3 whitespace-pre-wrap text-sm">{item.description}</p>
      {item.pageUrl && <p className="mt-2 break-all text-xs text-muted">Pagina: {item.pageUrl}</p>}
      <p className="mt-1 text-xs text-muted">Email: {item.emailStatus}</p>
      {item.attachments?.length > 0 && <div className="mt-3 flex flex-wrap gap-2">{item.attachments.map((attachment) => <button key={attachment.id} type="button" onClick={() => downloadAttachment(item.id, attachment)} className="flex items-center gap-1 rounded-full border border-edge px-3 py-2 text-xs"><Download size={14} />{attachment.name}</button>)}</div>}
      <div className="mt-4 flex flex-wrap gap-2"><button type="button" onClick={() => changeState(item.id, "in-review")} className="rounded-full border border-edge px-3 py-2 text-xs">In revisione</button><button type="button" onClick={() => changeState(item.id, "resolved")} className="rounded-full bg-emerald-700 px-3 py-2 text-xs text-white">Risolta</button><button type="button" onClick={() => changeState(item.id, "closed")} className="rounded-full bg-ink px-3 py-2 text-xs text-white">Chiudi</button></div>
    </article>)}</div>
  </section>;
}
